module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/6a8d3a5b7fc425f50bcaf400ce3a71d7.png";